module.exports = __webpack_public_path__ + "img/ic_chevron_down.80c506bc.svg";